import { OmButton, OmCarouselContainer } from '@om/component-library-react';
import { graphql } from 'gatsby';
import React from 'react';
import { ThemeContext } from '../context/ThemeContext';
import YoutubeCard from './YoutubeCard';
import './YoutubeCardContainer.scss';

const YoutubeCardContainer = ({ youtubeCardContainerContent }) => {
    const theme = React.useContext(ThemeContext);

    if (!youtubeCardContainerContent) {
        return ' ';
    }

    const {
        youtube_channel_link,
        carousel_header,
        carousel_sub_heading,
        youtube_channel_text,
        youtube_cards,
    } = youtubeCardContainerContent;

    return (
        <div className="youtube-container-wrapper">
            <h4 className={`${theme} carousel-header`}>
                {carousel_header ? carousel_header : 'Take a look at some of our videos'}
            </h4>
            {carousel_sub_heading ? (
                <h6 className={`${theme} carousel-sub-header`}>{carousel_sub_heading}</h6>
            ) : (
                ''
            )}

            {youtube_cards ? (
                <OmCarouselContainer
                    className="youtube-carousel"
                    numberOfCards={youtube_cards.length}
                >
                    {youtube_cards.map((value, index) => {
                        return (
                            <li key={index} slot={`carousel-card-` + (index + 1)}>
                                <YoutubeCard
                                    youtubeCardContent={{
                                        videoUrl: value.video_url,
                                        productCardCategory: 'video',
                                        productCardHeader: value.video_header,
                                        productCardCopy: value.video_copy,
                                    }}
                                />
                            </li>
                        );
                    })}
                </OmCarouselContainer>
            ) : (
                ''
            )}
            <OmButton
                className="youtube-channel-button"
                type="text"
                withIcon={true}
                iconName="arrow_forward"
                text={youtube_channel_text ? youtube_channel_text : 'visit our youtube channel'}
                actionType="URL"
                openTab={true}
                size="large"
                url={youtube_channel_link}
            />
        </div>
    );
};

export const pageQuery = graphql`
    fragment YoutubeCardContainer on Contentstack_youtube_carousel_container {
        youtube_channel_link
        carousel_header
        carousel_sub_heading
        youtube_channel_text
        youtube_cards {
            ...YoutubeCard
        }
    }
`;

export default YoutubeCardContainer;
